var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.item.visible)?_c('router-link',{staticClass:"navbar-item",attrs:{"exact-path":"","active-class":"is-active","to":{ name: _vm.item.name }}},[_vm._v("\n    "+_vm._s(_vm.item.label)+"\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }